module.exports = __webpack_public_path__ + "static/img-11-7ae7d1b3585d4fcaf57e975a65224c60.jpeg";